import { parse } from "query-string";
import { useLocation } from "react-router";
import { useWithDefaultParams } from "Services/useWithDefaultParams";

const URL_PARAMS_KEY = {
	providers: (id) => `provider.id=${id}`,
	rating: (type) => `rating_type=${type}`,
	service: (id) => `order_type_id=${id}`,
	dody: (id) => `dody.global_id=${id}`,
	district: (id) => `districts.id=${id}`,
	speed: (left, right) => `internet.speed_in>${left - 1}&internet.speed_in<${right * 1.0 + 1}`,

	price: (left, right) => `displayPrice>${left - 1}&displayPrice<${right * 1.0 + 1}`,
	gigabytes: (left, right) =>
		`mobile_new.internet>${left - 1}&mobile_new.internet<${right * 1.0 + 1}`,
	minutes: (left, right) => `mobile_new.calls>${left - 1}&mobile_new.calls<${right * 1.0 + 1}`,
};

export const useGetFilterFromParams = () => {
	const match = useWithDefaultParams();
	const location = useLocation();
	const filters = [];
	let urlParams = parse(location.search);

	const filtersFromUrl = Object.entries(urlParams).map(([key, value]) =>
		URL_PARAMS_KEY[key]?.(...value.split(","))
	);

	if (match.params.regionUrl) {
		filters.push(`region.url=${match.params.regionUrl}`);
	}
	if (match.params.tagCode) {
		filters.push(`mobile_new.tag_mobil.translit=${match.params.tagCode}`);
	}

	if (match.params.providerName) {
		filters.push(`provider.url_name=${match.params.providerName}`);
	} else {
		if (match.params.operator) {
			filters.push(`provider.url_name=${match.params.operator}`);
		}
	}

	const allFilters = [...filters, ...filtersFromUrl];

	return {
		filter: allFilters.join("&"),
	};
};
